var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-tiktok {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 5.69px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_33",
    "data-name": "Trazado 33",
    className: "cls-tiktok",
    d: "M52.88,7.54c0-1.32,1.07-2.39,2.39-2.39h14.32c1.32,0,2.39,1.07,2.39,2.39,0,14.49,11.74,26.25,26.24,26.25h.01c1.32,0,2.39,1.07,2.39,2.39h0v14.32c0,1.32-1.07,2.39-2.39,2.39-9.4.01-18.57-2.91-26.23-8.37v29.85c0,17.14-13.89,31.03-31.03,31.03s-31.03-13.89-31.03-31.03,13.89-31.03,31.03-31.03h0c1.32,0,2.39,1.07,2.39,2.39v14.34c0,1.32-1.07,2.38-2.39,2.39-6.6,0-11.96,5.35-11.96,11.96s5.35,11.96,11.96,11.96,11.96-5.35,11.96-11.96h0s-.05-66.87-.05-66.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokTop);
export default __webpack_public_path__ + "static/media/tiktok-top.80396b6d8383e1114f4245c2660b3630.svg";
export { ForwardRef as ReactComponent };